import { auth } from '../../firebase/firebaseSetup';
import { storageRef } from '../../firebase/firebaseSetup';

import {
    deleteObject,
    ref,
    StorageReference,
    list,
    ListResult,
    SettableMetadata
} from 'firebase/storage';

import AbstractService from '../abstract/abstractService';
import ImageService from '../services/imageService';
import ErrorInterface from '../interfaces/errorInterface';
import { OwnerClass } from '../ownership';

export default class OwnerService<
    O extends OwnerClass
> extends AbstractService<O> {
    logged: Record<string, any>;
    imageService: ImageService;

    constructor(identifier: string, customClass: any) {
        super(identifier, customClass);
        this.logged = auth.currentUser?.toJSON() || {};
        this.imageService = new ImageService(identifier);
    }
    /**
     * Delete a document from the collection and all its files
     * @param id id of the item to be deleted
     * @returns void
     */
    remove = async (id: string): Promise<void | ErrorInterface> => {
        const path = `${this.collectionId}/${id}`;
        const listFiles = (await list(
            ref(storageRef.root, path)
        )) as ListResult;
        const promises = listFiles.items.map((item: StorageReference) =>
            deleteObject(item)
        );
        await Promise.all(promises);
        await this.delete(id);
        return;
    };

    uploadFile = async (
        file: File,
        item: O,
        metadata?: SettableMetadata
    ): Promise<O> => {
        const url = await this.imageService.uploadFile(file, item, metadata);
        item.images = [...((item.images || []) as string[]), url as string];

        const saved = await this.save(item);
        return saved as O;
    };

    deleteFile = async (imageURL: string, item: O): Promise<O> => {
        await this.imageService.deleteFile(imageURL);
        if (item.imageFav === imageURL) {
            item.imageFav = undefined;
        }
        item.images = (item.images || []).filter(
            (url: string) => url !== imageURL
        );
        return (await this.save(item)) as O;
    };
}
